module.exports = __webpack_public_path__ + "91b5f5c663efb791780934a10f3d8f98.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/pirate-ship-empty.png
// module id = 335
// module chunks = 0